import { AfterViewInit, Component } from '@angular/core';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { BottomSheetContext } from 'swipe-bottom-sheet/angular';

@Component({
  selector: 'app-bottom-sheet-context-menu',
  templateUrl: './bottom-sheet-context-menu.component.html',
  styleUrls: ['./bottom-sheet-context-menu.component.scss']
})
export class BottomSheetContextMenuComponent {
    MenuItems: ContextMenuElement[];

    constructor(public bottomSheetContext: BottomSheetContext<any>) {}
}
